import { Pipe, PipeTransform } from 'angular-ts-decorators';
import { isEmpty } from 'lodash';

export type IsEmptyFilter = (input: any) => boolean;

interface IIsEmpty {
  transform: IsEmptyFilter;
}

/**
 * Filter that checks if a value is is empty or not
 * @param {any} input usually an object or an array
 * @return {boolean} It returns true for non empty object, string
 * array; and false for empty ones. For different input types it always returns
 * true.
 */
@Pipe({ name: 'isEmpty' })
export class IsEmptyPipe implements PipeTransform, IIsEmpty {
  constructor() {
    'ngInject';
  }

  public transform(input: any): boolean {
    return isEmpty(input);
  }
}
